<template>
  <tr>
    <td>{{ user.FirstName }}</td>
    <td>{{ user.LastName }}</td>
    <td>{{ user.Email }}</td>
    <td>{{ user.Username }}</td>
    <td>
      <v-btn icon :disabled="deletionSuccess || isLastUser" @click="openDeleteCurrentUserDialog">
        <v-icon>delete</v-icon>
      </v-btn>
      <RemoteAgencyCurrentUserDeleteDialog :show-current-delete-user-dialog="showCurrentDeleteUserDialog" :first-name="user.FirstName" :last-name="user.LastName" :email="user.Email" :username="user.Username" @success="deleteUser" @close="showCurrentDeleteUserDialog = false"></RemoteAgencyCurrentUserDeleteDialog>
    </td>
  </tr>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import RemoteAgencyCurrentUserDeleteDialog from './RemoteAgencyCurrentUserDeleteDialog.vue';

export default {
  name: 'RemoteAgencySeatRow',
  components: {
    RemoteAgencyCurrentUserDeleteDialog
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    hostType: {
      type: Number,
      required: true
    },
    totalUsers: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      deletionSuccess: false,
      showCurrentDeleteUserDialog: false
    };
  },
  computed: {
    ...mapState(['agency', 'agencyUser']),
    ...mapGetters(['getVisibleRemoteAgencySeats']),
    isLastUser () {
      return this.getVisibleRemoteAgencySeats.length === 1;
    }
  },
  methods: {
    ...mapActions(['setSeatChangeDeletionError', 'setSeatChangeDeletionSuccess', 'setRemoteAgencySeatDisplay', 'addPendingSeatManagementRequest']),
    openDeleteCurrentUserDialog () {
      this.showCurrentDeleteUserDialog = true;
    },
    async deleteUser () {
      var payload = {
        AgencyId: this.agency.agencyId,
        AgencyName: this.agency.name,
        RequestedBy: this.agencyUser.name,
        Quantity: -1,
        AgencyType: this.hostType,
        FirstName: this.user.FirstName,
        LastName: this.user.LastName,
        Email: this.user.Email
      };
      var response = await this.$api.createAgencySeatRequest(payload);
      if (response.code !== 0 && response.code !== 2) {
        this.setSeatChangeDeletionError(true);
        return;
      }
      var id = JSON.parse(response.data[0]).data[0];

      this.setSeatChangeDeletionSuccess(true);
      this.setRemoteAgencySeatDisplay(this.user);
      this.addPendingSeatManagementRequest({ email: this.user.Email, firstName: this.user.FirstName, lastName: this.user.LastName, id: id, quantity: -1, requestedBy: this.agencyUser.name, status: 'Available' });
      this.deletionSuccess = true;
    }
  }
};
</script>

<style scoped>
</style>
